/**
 * UTMify pixel ID.
 *
 * Paste the real ID from your UTMify dashboard (Pixels → your pixel) here.
 * While this is empty, only the UTM-tracking script loads — the pixel script is
 * skipped on purpose, because UTMify's pixel.js throws
 * ("undefined is not an object (evaluating 'lead._id')") when it is
 * initialized with an ID its backend does not recognize.
 */
const UTMIFY_PIXEL_ID = ''

let loaded = false

/**
 * Loads the official UTMify scripts.
 * Safe to call multiple times: it only injects the scripts once.
 */
export function loadUtmify(): void {
  if (loaded || typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  loaded = true

  // Official UTMify UTM parameter tracking script (carries UTMs into checkout).
  const utmScript = document.createElement('script')
  utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
  utmScript.async = true
  utmScript.defer = true
  utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
  utmScript.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(utmScript)

  // Official UTMify pixel script — only with a real, configured pixel ID.
  const pixelId = UTMIFY_PIXEL_ID.trim()
  const isPlaceholder = pixelId.length === 0 || /^0+$/.test(pixelId)
  if (isPlaceholder) {
    return
  }

  const w = window as unknown as { pixelId?: string }
  w.pixelId = pixelId

  const pixelScript = document.createElement('script')
  pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
  pixelScript.async = true
  pixelScript.defer = true
  document.head.appendChild(pixelScript)
}
